// extracted by mini-css-extract-plugin
export default {"container":"Home_container__4u2hC"};